import { Component } from '@angular/core';

@Component({
    selector   : 'fuse-demo-content',
    template: require('./demo-content.component.html'),
    styles: [require('./demo-content.component.scss')]
})
export class FuseDemoContentComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
